export default ($axios) => ({
  fetchUsage(query) {
    return $axios.get('/usage', { params: query }).then((response) => response.data);
  },
});
